"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const Title = ({ title, subtitle }) => ((0, jsx_runtime_1.jsxs)(styles_1.TitleWrapper, { children: [title && (0, jsx_runtime_1.jsx)("h5", { children: title }), subtitle && (0, jsx_runtime_1.jsx)("p", { children: subtitle })] }));
exports.default = Title;
